import { uiFb } from '@/lib/i18n';

interface Archetype {
  id: 'traveler' | 'student' | 'expat' | 'scheduler';
  href: string;
  emojiKey: string;
  emojiFallback: string;
  titleKey: string;
  titleFallback: string;
  blurbKey: string;
  blurbFallback: string;
}

const ARCHETYPES: Archetype[] = [
  {
    id: 'traveler',
    href: '/best-time-to-visit-indonesia',
    emojiKey: 'ui.archetype.traveler_emoji',
    emojiFallback: '🌴',
    titleKey: 'ui.archetype.traveler_title',
    titleFallback: "I'm a traveler",
    blurbKey: 'ui.archetype.traveler_blurb',
    blurbFallback: 'Best months, weather, festivals, and long weekends to plan a trip',
  },
  {
    id: 'student',
    href: '/snbp-2026',
    emojiKey: 'ui.archetype.student_emoji',
    emojiFallback: '🎓',
    titleKey: 'ui.archetype.student_title',
    titleFallback: "I'm a student",
    blurbKey: 'ui.archetype.student_blurb',
    blurbFallback: 'University admissions, academic calendars, exam periods, and orientation',
  },
  {
    id: 'expat',
    href: '/indonesia-public-holidays',
    emojiKey: 'ui.archetype.expat_emoji',
    emojiFallback: '🏠',
    titleKey: 'ui.archetype.expat_title',
    titleFallback: "I'm an expat",
    blurbKey: 'ui.archetype.expat_blurb',
    blurbFallback: 'Public holidays, religious observances, and bank closures in your country',
  },
  {
    id: 'scheduler',
    href: '/today',
    emojiKey: 'ui.archetype.scheduler_emoji',
    emojiFallback: '🗓️',
    titleKey: 'ui.archetype.scheduler_title',
    titleFallback: 'I plan for teams',
    blurbKey: 'ui.archetype.scheduler_blurb',
    blurbFallback: "What's happening today across regions, and what's coming this week",
  },
];

export function ArchetypeRouter({ lang = 'en' }: { lang?: string }) {
  return (
    <section
      id="archetype-router"
      aria-label={uiFb('ui.archetype.heading', 'Pick a starting point', lang)}
      className="px-4 py-10 md:px-8 lg:px-16 xl:px-20"
    >
      <div className="mx-auto max-w-5xl">
        <h2 className="mb-6 text-center font-heading text-2xl font-bold tracking-tight text-text-primary md:text-3xl">
          {uiFb('ui.archetype.heading', 'Pick a starting point', lang)}
        </h2>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {ARCHETYPES.map((a) => (
            <a
              key={a.id}
              href={a.href}
              className="group flex flex-col gap-2 rounded-xl border border-border-subtle bg-surface-card p-5 text-left transition-colors hover:border-brand/40 hover:bg-surface-hover"
            >
              <span className="text-2xl" aria-hidden="true">
                {uiFb(a.emojiKey, a.emojiFallback, lang)}
              </span>
              <span className="font-heading text-base font-semibold text-text-primary group-hover:text-brand">
                {uiFb(a.titleKey, a.titleFallback, lang)}
              </span>
              <span className="text-sm leading-snug text-text-secondary">
                {uiFb(a.blurbKey, a.blurbFallback, lang)}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
